module.exports = __webpack_public_path__ + "img/google-play-badge.e3a54910.png";